// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index.bundle." + "aa401373c11fd917a3ed" + ".js";
};